import React from "react";
import { useHistory } from "react-router-dom";
import * as func from "../../../utils/funcs";

import styles from "./RakazButtons.module.css";

function RakazButtons(props) {
  const { user, leagueId, roundId } = props;
  const history = useHistory();

  const handleClickNewRound = () => {
    history.push(`/leagues/${leagueId}/addround`);
  };

  const handleClickNewMatch = () => {
    history.push(`/leagues/${leagueId}/rounds/${roundId}/addmatch`);
  };

  return (
    <div className={styles.rakazBtns}>
      <div
        className={styles.sign}
        onClick={handleClickNewRound}
        style={
          func.validRakazLeague(user)
            ? { display: "block" }
            : { display: "none" }
        }
      >
        <div className={styles.newRoundSign}>
          <div className={styles.pass}></div>
          <div className={styles.pass}></div>
          <div className={styles.pass}></div>
        </div>
        <div className={styles.btnText}>מחזור חדש</div>
      </div>

      <div
        className={styles.sign}
        onClick={handleClickNewMatch}
        style={
          func.validRakazLeague(user)
            ? { display: "block" }
            : { display: "none" }
        }
      >
        <div className={styles.newMatchSign}></div>
        <div className={styles.btnText}>משחק חדש</div>
      </div>
    </div>
  );
}

export default RakazButtons;
